import req from './request'

const DEFAULT_ENDPOINTS = {
    setting: '/payout-statements/setting',
    reference: '/payout-statements/setting/reference',
    default: '/payout-statements/default',
    defaultRef: '/payout-statements/default/reference',
    list: '/payout-statements/items/list',
    import: '/payout-statements/default/import',
    delete: '/payout-statements/items/delete',
    pay: '/payout-statements/default/pay',
    interrup: '/payout-statements/default/interrupt',
    items: '/payout-statements/items',
    details: '/payout-statements/items/detail',
    resolveServices: '/payout-statements/default/resolve-services'
}

export default {
    setting(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.setting, param)
    },
    reference(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.reference, param)
    },
    default(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.default, param)
    },
    defaultRef(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.defaultRef, param)
    },
    list(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.list, param)
    },
    import(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.import, param)
    },
    delete(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.delete, param)
    },
    pay(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.pay, param)
    },
    interrup(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.interrup, param)
    },
    details(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.details, param)
    },
    items(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.items, param)
    },
    resolveServices(payload, param, method) {
        return req[method || 'get'](payload, DEFAULT_ENDPOINTS.resolveServices, param)
    }
}